import { render, staticRenderFns } from "./PeriodObservations.vue?vue&type=template&id=75592a07"
import script from "./PeriodObservations.vue?vue&type=script&lang=js"
export * from "./PeriodObservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports